import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API, TOKEN_KEY } from "@/lib/api";

let last = { path: null, at: 0 };

/** Anonymous page-view beacon for Admin → Statistikk. Skipped for the board's own visits (admin token) and Do-Not-Track. */
export const usePageTracking = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = setTimeout(() => {
      if (last.path === pathname && Date.now() - last.at < 2000) return;
      if (localStorage.getItem(TOKEN_KEY) || navigator.doNotTrack === "1" || window.doNotTrack === "1") return;
      last = { path: pathname, at: Date.now() };
      fetch(`${API}/public/track`, { method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true,
        body: JSON.stringify({ path: pathname, ref: document.referrer || null, w: window.innerWidth }) }).catch(() => {});
    }, 400);
    return () => clearTimeout(t);
  }, [pathname]);
};
